import { createCouponApp } from './app';
import { initializeLiff } from './lib/liff';
import type { MockCouponScenario } from './mock/coupons';
import './styles/main.css';

const root = document.getElementById('app');
if (!root) throw new Error('Application root is missing.');

const useMock = import.meta.env.VITE_USE_MOCK_COUPONS === 'true';
const configuredScenario = import.meta.env.VITE_MOCK_COUPON_SCENARIO;
const mockScenario: MockCouponScenario = configuredScenario === 'empty' ? 'empty' : 'multiple';

try {
  await initializeLiff(import.meta.env.VITE_LIFF_ID);
} catch {
  // LIFF設定前や一時的な初期化失敗でも、公開クーポン一覧は通常Webとして表示します。
}

const app = createCouponApp(root, {
  endpoint: import.meta.env.VITE_PUBLIC_RAKUTEN_COUPONS_URL ?? '',
  useMock,
  mockScenario,
});

await app.load();
